module.exports = __webpack_public_path__ + "img/money.a953f4dc.svg";